<template>
  <v-row
    no-gutters
    justify="center"
    style="position: relative"
    v-click-outside="onClickOutside"
  >
    <v-card
      v-if="setSelfie"
      height="100"
      width="100"
      style="overflow: hidden"
      class="rounded-lg"
    >
      <v-progress-linear
        v-show="loadingCamera"
        indeterminate
        color="primary"
        height="100"
      ></v-progress-linear>
      <div
        v-show="setSelfie"
        class="d-flex align-center justify-center"
        style="
          width: 100%;
          height: 100%;
          position: absolute;
          z-index: 3;
          margin-top: 10px;
        "
      >
        <p class="count-down" v-if="!loadingCamera && countDown == 3">3</p>
        <p class="count-down" v-if="!loadingCamera && countDown == 2">2</p>
        <p class="count-down" v-if="!loadingCamera && countDown == 1">1</p>
      </div>

      <vue-web-cam
        v-show="setSelfie"
        class="webcam"
        :class="{ 'reverse-camera': reverseCamera }"
        ref="webcam"
        :device-id="deviceId"
        height="100%"
        @started="onStarted"
        @stopped="onStopped"
        @error="onError"
        @cameras="onCameras"
        @camera-change="onCameraChange"
      />
    </v-card>
    <v-img
      v-else
      alt="Profile"
      class="shrink d-flex align-center"
      style="background-color: var(--v-primary-base)"
      :src="imageUrl ? imageUrl : pictureUrl"
      width="100"
      height="100"
      :contain="fullScreenPicture"
      :class="{
        fullScreenPicture: fullScreenPicture,
        'rounded-lg': !fullScreenPicture,
      }"
      @click="!setSelfie ? (fullScreenPicture = !fullScreenPicture) : null"
      ><template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular
            v-if="pictureUrl"
            indeterminate
            color="grey lighten-5"
          ></v-progress-circular>
        </v-row> </template
      ><v-btn
        icon
        v-if="!pictureUrl && !setSelfie && !imageUrl"
        class="mt-1"
        style="margin-left: 32px"
        @click="onStart()"
      >
        <v-icon size="60" color="white">mdi-camera</v-icon>
      </v-btn></v-img
    >
    <div
      v-if="fullScreenPicture"
      class="my-0 py-0 d-flex justify-center"
      style="z-index: 3; position: fixed; bottom: 20px; right: 0; left: 0px"
    >
      <v-btn
        depressed
        large
        class="text-none rounded-pill"
        color="primary"
        @click="onStart(), (fullScreenPicture = false)"
        >{{ $t("picture.modify") }}
      </v-btn>
    </div>
  </v-row>
</template>
<script>
import { WebCam } from "vue-web-cam";
import { mapGetters } from "vuex";

export default {
  props: ["before", "after"],
  components: {
    "vue-web-cam": WebCam,
  },
  data: () => ({
    valid: true,
    model: null,
    menu: false,
    countDown: 4,
    loadingCamera: false,
    setSelfie: false,
    camera: null,
    deviceId: null,
    devices: [],
    imageUrl: null,
    reverseCamera: true,
    fullScreenPicture: false,
  }),
  watch: {
    camera: function (id) {
      // console.log("camera ", id);
      this.deviceId = id;
    },
    devices: function () {
      // console.log("devices ", this.devices);
      const [first, second, ...tail] = this.devices;
      if (second) {
        this.camera = second.deviceId;
        this.deviceId = second.deviceId;
        this.reverseCamera = false;
      } else if (first) {
        this.camera = first.deviceId;
        this.deviceId = first.deviceId;
        this.reverseCamera = true;
      }
    },
  },
  computed: {
    pictureUrl() {
      if (this.before) {
        return this.selectedMarker.beforePictureUrl;
      }
      if (this.after) {
        return this.selectedMarker.afterPictureUrl;
      }
    },
    ...mapGetters(["selectedMarker"]),
    dialogProfile: {
      get() {
        return this.$store.state.dialogProfile;
      },
      set(val) {
        return this.$store.commit("setDialogProfile", val);
      },
    },
    device: function () {
      return this.devices.find((n) => n.deviceId === this.deviceId);
    },
    user: {
      get: function () {
        return this.$store.state.user;
      },
      set: function (newValue) {
        this.$store.commit("setUser", newValue);
      },
    },
  },
  methods: {
    setFullScreenPicture() {
      this.fullScreenPicture = true;
    },
    onClickOutside() {
      this.imageUrl = null;
    },

    onCapture() {
      this.setSelfie = false;
      let image = this.$refs.webcam.capture();
      this.imageUrl = image;
      this.onStop();
      this.$store.dispatch("uploadItem", {
        image: image,
        folder: this.before ? "before" : "after",
        field: this.before ? "beforePictureUrl" : "afterPictureUrl",
        target: "marker",
      });
    },
    onStarted(stream) {
      this.loadingCamera = false;
      let self = this;
      setTimeout(function () {
        self.onCapture();
        self.countDown = "";
      }, 3000);
      setTimeout(function () {
        self.countDown = 1;
      }, 2000);
      setTimeout(function () {
        self.countDown = 2;
      }, 1000);
      this.countDown = 3;
    },
    onStopped(stream) {},
    onStop() {
      this.$refs.webcam.stop();
    },
    onStart() {
      this.setSelfie = true;
      this.loadingCamera = true;
      if (this.$refs.webcam) this.$refs.webcam.start();
    },
    onError(error) {
      console.log(error);
    },
    onCameras(cameras) {
      this.devices = cameras;
      this.onStart();
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
      this.camera = deviceId;
    },
    save(field, value) {
      this.$store.commit("setSnackbar", {
        color: "success",
        timeout: 3000,
        text: this.$i18n.t("dialogProfile.saved"),
      });
      let update = {};
      update[field] = value;
      this.$store.dispatch("updateUser", update);
    },
  },
};
</script>


<style>
/* * {
  border: solid 1px red;
} */
.reverse-camera {
  transform: scaleX(-1);
}
@keyframes countDown {
  0% {
    transform: scale(2.5);
  }
  100% {
    transform: scale(1);
  }
}
.count-down {
  font-size: 50px;
  color: white;
  animation: countDown 2s;
}

@keyframes zoominoutselfie {
  0% {
    transform: scale(1) scaleX(-1);
  }
  50% {
    transform: scale(0.9) scaleX(-1);
  }
  100% {
    transform: scale(1) scaleX(-1);
  }
}
@keyframes appear {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.webcam {
  object-fit: cover;
}
.v-slide-group__wrapper {
  padding-right: 20px;
}

.fullScreenPicture {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  width: 100vw !important;
  height: 100vh !important;
  animation: fadein 0.2s;
  transform-origin: 50% 50%;
  background-color: transparent !important;
  backdrop-filter: blur(6px);
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
